// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"627":"7e84a2595c92bbb267ec","873":"d420334e8a47314dfb9e","989":"540a4180f95c1d451e6f"}[chunkId] + ".js";
};